import { render, staticRenderFns } from "./accompanyingPassport.vue?vue&type=template&id=8baa9422&scoped=true"
import script from "./accompanyingPassport.vue?vue&type=script&lang=js"
export * from "./accompanyingPassport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baa9422",
  null
  
)

export default component.exports